import React from "react";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import Dropdown from "../Dropdown/dropdown";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";

interface IProps {
  onClassSelect: (selectedClass: any) => unknown;
  selectedClassId: number | null;
}

export const ClassOptionsDropdown = ({
  onClassSelect,
  selectedClassId,
}: IProps) => {
  const { isLoading: isClassOptionsLoading, data: CLASSES_OPTIONS } =
    useGetClassesOptions();

  if (isClassOptionsLoading) return <div />;

  return (
    <Dropdown
      label="Class"
      options={CLASSES_OPTIONS || []}
      selectedOption={getSelectedOptionFromValue(
        CLASSES_OPTIONS || [],
        selectedClassId
      )}
      setSelectedOption={(option) => {
        onClassSelect(option);
      }}
    />
  );
};
